export default __webpack_public_path__ + "static/terminal-transporte-f6bec5abf654cf345cb30327e20b8782.jpg";